import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Logger } from '../../../../../projects/common/src/app/classes';
import { CommunicationService } from '../../../services/communication';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { CacheService } from 'projects/common/src/app/services';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UrlBuilderService } from 'projects/communication/src/app/services';

@Injectable({
  providedIn: 'root',
})
export class ReportMonthlyStatePerOperatorService extends Logger {
  private baseUrl: string;
  constructor(
    private http: HttpClient,
    private communicationService: CommunicationService,
    private cacheService: CacheService,
    private urlBuilder: UrlBuilderService,
  ) {
    super();
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   * Function get Data
   */
  public getReportMonthlyStatePerOperator(selectedFilters: IOutputFilter) {
    const params = this.setParams(selectedFilters);
    const url = `${this.baseUrl}/Report/GetMonthlyStatePerOperatorReport`;
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * Function to get report excel
   */
  public getReportMonthlyStatePerOperatorExcel(selectedFilters: IOutputFilter): Observable<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.urlBuilder.apiUrl}/Report/GetMonthlyStatePerOperatorReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * Set and send filters
   *
   * @param selectedFilters Filters selected to save params
   */
  public setParams(selectedFilters: IOutputFilter): any {
    const companyId = this.cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      zoneId: selectedFilters.zoneId,
      companyId,
    };
  }
}
